<!-- Runmode:A1/A1O/FAD/B/BO/C1/C1O/A4/A4O用のコンポーネント -->
<template>
  <div class="a1">
    <PinchInQue v-show="isShowPinchIn" :pinchInText="pinchInText" :pathstep="pathstep" :pinchInShowVoice="showQestionVoice"
        :pinchInSound="pinchInSound" @pinchOut="recievePinchOut" @pinchiInAudioPlay="audioPlay" @pinchInaudioPause="audioPause()"/>
    <PinchInActStore/>
    <div class="page-content">
      <div class="inner flexrow" :class="cssLayoutID">
        <div v-if="isMobile()" class="toparea-play" :style="{ visibility: isAutoAdjustShown ? 'visible' : 'hidden' }">
          <div class="flexcenter" :style="{ visibility: showSelectAnswer ? 'visible' : 'hidden' }">
            <!-- 問題データ & 再生アイコン -->
            <div class="item" @touchstart="onTouchStart(eText)" @touchend="onTouchEnd()" @touchmove="onTouchEnd()"
                 @mousedown="$emit('hintMouseDown', $event)" @mouseup="$emit('hintMouseUp', $event)"
                 @mousemove="$emit('hintMouseMove', $event)">
              <div class="input w300">
                <span v-show="showQestionText" v-html="eText" />
              </div>
              <button v-show="showQestionText && showPinchInBtn" class="icon-pinch-in" @click="clickPinchIn(eText)"></button>
              <button v-show="showQestionVoice" class="icon-voice" @click="audioPlay(currentData.sounds[0])"></button>
            </div>
          </div>
        </div>
        <div v-else class="toparea-play">
          <div class="flexcenter" v-show="showSelectAnswer">
            <!-- 問題データ & 再生アイコン -->
            <div class="item" @touchstart="onTouchStart(eText)" @touchend="onTouchEnd()" @touchmove="onTouchEnd()"
                 @mousedown="$emit('hintMouseDown', $event)" @mouseup="$emit('hintMouseUp', $event)"
                 @mousemove="$emit('hintMouseMove', $event)">
              <div class="input w300" :class="getTextFontClassQue(eText, productLanguage)">
                <span v-show="showQestionText" v-html="getPopupTextElem(eText)" />
              </div>
              <button v-show="showQestionText && showPinchInBtn" class="icon-pinch-in" @click="clickPinchIn(eText)"></button>
              <button v-show="showQestionVoice" class="icon-voice" @click="audioPlay(currentData.sounds[0])"></button>
            </div>
          </div>
        </div>

        <CommonAct :pathstep="pathstep" :activeType="activeType" :actChoice="true" :horizontalRow="false" :scriptSystems="scriptSystems" :needsSwiper="false" :isImageTextAutoAdjust="true"
                   :answerAct="currentData" :isShowTextsParent="isShowTextsParent" :isShowVoicesParent="isShowVoicesParent" :isActivesParent="isActivesParent"
                   :changeActives="changeActives" :changeEndAct="changeEndAct" :changeIsShowTexts="changeIsShowTexts" :changeIsShowVoices="changeIsShowVoices"
                   :isScrollIconVisible="isScrollIconVisible"
                   @actCorrect="recieveActCorrect" @actInCorrect="recieveActInCorrect" @audioPause="audioPause()" @changeActSelect="isChangeSelectAct = true"
                   @updateLearnedGroup="$emit('updateLearnedGroup')" @actPinchIn="recieveActPinchIn"/>

      </div><!-- /inner -->
    </div><!-- /page-content -->
  <!-- /a1 -->
  </div>
</template>

<script>
// 共通処理
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import audio from "@/mixin/audio";
import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";

import Vue from "vue";
import Vuex from "vuex";
// コンポーネント
import CommonAct from "./CommonAct";
import PinchInQue from "./PinchInQue";
import PinchInActStore from "./PinchInActStore";

export default {
  name: "A1",
  props: {
    pathstep: Object,
    productLanguage: String,
    scriptSystems: Object,
    isScrollIconVisible: Boolean
  },
  mixins: [
    common,
    runmode,
    audio,
    constants
  ],
  data() {
    return {
      // 出題用テキスト
      eText: "",
      // 出題対象のactData
      currentData: null,
      // 回答選択欄表示フラグ
      showSelectAnswer: false,
      // 正解／不正解を判断するフラグ（storeコミット用）
      isActState: true,
      // 画像選択可能かを判断するフラグ
      isSelect: false,
      // 出題用のテキスト表示するかを判断するフラグ
      showQestionText: false,
      // 出題用の音声再生アイコンを表示するかを判断するフラグ
      showQestionVoice: false,
      // givenの問題をまとめたactの配列
      givenActs: [],
      // 全問正解時のタイマー
      allCorrectTimer: null,
      // 適用するレイアウトクラス
      activeType: "active-type1",
      // Actのテキスト表示するかを判断するBoolean配列
      isShowTextsParent: [],
      // Actの音声再生アイコンを表示するかを判断するBoolean配列
      isShowVoicesParent: [],
      // activeクラスを適用するかを判断するBoolean配列
      isActivesParent: [],
      // 監視用のステータス(Active)
      changeActives: false,
      // 監視用のステータス(EndAct)
      changeEndAct: false,
      isChangeSelectAct: false,
      // ピンチインを表示するかを判断するフラグ
      isShowPinchIn: false,
      // ピンチイン対象のテキストを設定する
      pinchInText: "",
      // ピンチインボタン表示フラグ
      showPinchInBtn: false,
      // ピンチイン対象の音声
      pinchInSound: "",
      // タッチイベント長押しタイマー
      touchTimer: null,
      changeIsShowTexts: false,
      changeIsShowVoices: false,
      tempCurrentData: null,
      // 正解時の処理を行っているか判断する
      isCorrectsState: false
    };
  },
  components: {
    CommonAct,
    PinchInQue,
    PinchInActStore
  },
  created: function() {
    this.$store.dispatch("initPinchInAct");
    this.init();
  },
  beforeDestroy: function() {
    var i = 0;
    while (i < this.pathstep.acts.length) {
      this.pathstep.acts[i].correct = false;
      i++;
    }
  },
  methods: {
    /**
    /* 初期化処理
     */
    init: function() {
      this.log("A1 start init");

      // ACTの取得
      this.pathstep.acts = this.getShuffleItems();
      // 拡大表示ボタン表示フラグ
      this.showPinchInBtn = this.isShowPinchInBtn(this.productLanguage, this.displayMode);

      // 出題用および各Actのテキスト／音声再生アイコンを表示するかを判定する
      this.isShowQestionText();
      this.isShowQestionVoice();
      this.initShowActText(this.pathstep.acts);
      this.initShowActVoice(this.pathstep.acts);
    },
    /**
     * givenの問題取得
     */
    givenQuestions: function() {
      this.log("A1 start givenQuestions");

      var i = 0;
      while (i < this.pathstep.acts.length) {
        if (this.isGiven(this.pathstep.acts[i])) {
          this.givenActs.push({ act: this.pathstep.acts[i], index: i });
        }
        i++;
      }

      this.givenPlaySounds();
    },
    /**
     * given問題の再生処理
     */
    givenPlaySounds: function() {
      this.log("A1 start givenPlaySounds");

      const self = this;

      if (this.givenActs.length == 0) {
        // 再生するgivenのActがない場合は、問題出題する
        for (var i = 0; i < this.pathstep.acts.length; i++) {
          if (this.isChallenge(this.pathstep.acts[i])) {
            this.challengeQuestion();
            return;
          }
        }
        return;
      }

      this.isActivesParent = [];
      this.isActivesParent[this.givenActs[0].index] = true;
      this.changeActives = true;

      this.audioPlay(this.givenActs[0].act.sounds[0]);
      var endedEvent = function() {
        $(self.myAudio).off("ended error", endedEvent);
        self.changeActives = false;
        self.givenActs.shift();

        self.setInterval(constants.QUESTION_INTERVAL).then(function() {
          self.givenPlaySounds();
        });
      };
      $(this.myAudio).on("ended error", endedEvent);
    },
    /**
     * challenge問題の出題処理
     */
    challengeQuestion: function() {
      this.log("A1 start challengeQuestion");

      var commonAct = this.$children.find(function(child) {
        return child.$options.name == constants.VUE_NAME_COMMONACT;
      });
      if (commonAct) {
        commonAct.isSelects = [];
      }

      const self = this;

      this.isActivesParent = [];
      this.changeActives = true;
      this.isChangeSelectAct = false;
      this.changeIsShowTexts = false;
      this.changeIsShowVoices = false;

      // 問題データの取得_ランダム
      if (this.tempCurrentData == null) {
        this.currentData = this.getQuestionRandom();
      } else {
        this.currentData = this.tempCurrentData;
        this.tempCurrentData = null;
      }

      if (this.currentData == null) {
        // 親(Runmode.Vue)に通知する
        this.changeEndAct = true;
        this.allCorrectTimer = setTimeout(function() {
          self.$emit("endAct");
        }, constants.ALLCORRECT_INTERVAL);
        return;
      }

      // 問題音声再生を実行する
      if (this.showQestionVoice) {
        this.audioPlay(this.currentData.sounds[0]);
      }

      // 問題文表示
      this.eText = this.getLanguageBasicText(this.currentData.texts, this.productLanguage, this.scriptType, this.displayMode, this.scriptSystems.default);
      // 回答選択欄の表示
      this.showSelectAnswer = true;
    },
    /**
     * Actの正解通知を受け取る
     */
    recieveActCorrect: function(showTexts, showVoices, index) {
      this.log("A1 start recieveActCorrect");

      const self = this;

      this.pathstep.acts[index].correct = true;
      this.setActState(this.isActState);
      this.isActState = true;

      // スコア表示中・全解答表示中は次の問題出題しない
      if (this.lessonState == storeConstants.LESSON_STATE_PAUSE || this.dispAllAnswerStatus) {
        this.showSelectAnswer = false;
        return;
      }

      if (this.isAllCorrect()) {
        this.isCorrectsState = true;

        this.showSelectAnswer = false;
        this.changeEndAct = true;

        // 親(Runmode.Vue)に通知する
        this.allCorrectTimer = setTimeout(function() {
          self.isCorrectsState = false;
          self.$emit("endAct");
        }, constants.ALLCORRECT_INTERVAL);
      } else {
        this.pathstep.acts = this.getShuffleItems();
        if (this.pathstep.challengeFillPolicy === "i") {
          this.isShowTextsParent = showTexts;
          this.isShowVoicesParent = showVoices;
        } else {
          this.initShowActText(this.pathstep.acts);
          this.initShowActVoice(this.pathstep.acts);
        }
        this.changeIsShowTexts = true;
        this.changeIsShowVoices = true;
        this.challengeQuestion();
      }
    },
    /**
     * Actの不正解通知を受け取る
     */
    recieveActInCorrect: function() {
      this.log("A1 start recieveActInCorrect");

      this.isActState = false;

      if (this.showQestionVoice) {
        if (!this.isChangeSelectAct && !this.isAudioPlaying && this.lessonState != storeConstants.LESSON_STATE_PAUSE && !this.dispAllAnswerStatus) {
          this.audioPlay(this.currentData.sounds[0]);
        }
      }
    },
    /**
     * 全解答表示時の処理
     */
    showAllAnswer: function() {
      this.log("A1 start showAllAnswer");

      // 出題文を非表示にする
      this.showSelectAnswer = false;
    },
    /**
     * 全解答解除時の処理
     */
    hideAllAnswer: function() {
      this.log("A1 start hideAllAnswer");

      this.showSelectAnswer = true;
    },
    /**
     * 出題用のテキストを表示するかを判定する
     */
    isShowQestionText: function() {
      this.log("A1 start isShowQestionText");

      switch (this.pathstep.mode) {
        case constants.RUNMODE_A1:
        case constants.RUNMODE_A1O:
        case constants.RUNMODE_FAD:
        case constants.RUNMODE_C1:
        case constants.RUNMODE_C1O:
          this.showQestionText = true;
          break;
        case constants.RUNMODE_B:
        case constants.RUNMODE_BO:
        case constants.RUNMODE_A4:
        case constants.RUNMODE_A4O:
          this.showQestionText = false;
          break;
        default:
          break;
      }
    },
    /**
     * 出題用の音声再生アイコンを表示するかを判定する
     */
    isShowQestionVoice: function() {
      this.log("A1 start isShowQestionVoice");

      switch (this.pathstep.mode) {
        case constants.RUNMODE_A1:
        case constants.RUNMODE_A1O:
        case constants.RUNMODE_FAD:
        case constants.RUNMODE_B:
        case constants.RUNMODE_BO:
        case constants.RUNMODE_A4:
        case constants.RUNMODE_A4O:
          this.showQestionVoice = true;
          break;
        case constants.RUNMODE_C1:
        case constants.RUNMODE_C1O:
          this.showQestionVoice = false;
          break;
        default:
          break;
      }
    },
    /**
     * 初期表示時に各Actのテキストを表示するかを判定する
     */
    initShowActText: function(acts) {
      this.log("A1 start initShowActText");
      var i = 0;
      while (i < acts.length) {
        switch (this.pathstep.mode) {
          case constants.RUNMODE_A1:
          case constants.RUNMODE_A1O:
          case constants.RUNMODE_FAD:
          case constants.RUNMODE_C1:
          case constants.RUNMODE_C1O:
            // givenのActのみテキストを表示する
            if (this.isChallenge(acts[i])) {
              this.isShowTextsParent[i] = false;
            } else {
              this.isShowTextsParent[i] = true;
            }
            break;
          case constants.RUNMODE_A4:
          case constants.RUNMODE_A4O:
            // 全てのActのテキストを表示する
            this.isShowTextsParent[i] = true;
            break;
          case constants.RUNMODE_B:
          case constants.RUNMODE_BO:
            // 全てのActのテキストを表示しない
            this.isShowTextsParent[i] = false;
            break;
          default:
            break;
        }
        i++;
      }
    },
    /**
     * 初期表示時に各Actの音声再生アイコンを表示するかを判定する
     */
    initShowActVoice: function(acts) {
      this.log("A1 start initShowActVoice");
      var i = 0;
      while (i < acts.length) {
        switch (this.pathstep.mode) {
          case constants.RUNMODE_A1:
          case constants.RUNMODE_A1O:
          case constants.RUNMODE_FAD:
          case constants.RUNMODE_B:
          case constants.RUNMODE_BO:
            // givenのActのみ音声再生アイコンを表示する
            if (this.isChallenge(acts[i])) {
              this.isShowVoicesParent[i] = false;
            } else {
              this.isShowVoicesParent[i] = true;
            }
            break;
          case constants.RUNMODE_C1:
          case constants.RUNMODE_C1O:
          case constants.RUNMODE_A4:
          case constants.RUNMODE_A4O:
            // 全てのActの音声再生アイコンを表示しない
            this.isShowVoicesParent[i] = false;
            break;
          default:
            break;
        }
        i++;
      }
    },
    /**
     * Runmode毎にquestionの出題方法を変更する
     */
    setQuestionType: function() {
      this.log("A1 start setQuestionType");

      switch (this.pathstep.mode) {
        case constants.RUNMODE_C1:
        case constants.RUNMODE_C1O:
        case constants.RUNMODE_A4:
        case constants.RUNMODE_A4O:
          this.challengeQuestion();
          break;
        case constants.RUNMODE_A1:
        case constants.RUNMODE_A1O:
        case constants.RUNMODE_B:
        case constants.RUNMODE_BO:
        case constants.RUNMODE_FAD:
          this.givenQuestions();
          break;
        default:
          break;
      }
    },
    /**
     * ピンチインボタン押下時の処理
     */
    clickPinchIn: function(text) {
      this.log("A1 start clickPinchIn");

      this.isShowPinchIn = true;
      this.pinchInText = text;
      this.pinchInSound = this.currentData.sounds[0];

      this.log("A1 clickPinchIn: set lessonState: " + storeConstants.LESSON_STATE_PAUSE);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);
    },
    /**
     * ピンチアウト押下通知を受け取る
     */
    recievePinchOut: function() {
      this.log("A1 start recievePinchOut");

      if (this.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
        // state更新して、レッスンを再開
        this.log("A1 recievePinchOut: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
      }
    },
    /**
     * 長押しイベント開始
     * @param String text 拡大表示するテキスト
     */
    onTouchStart: function(text) {
      var self = this;
      if (!this.showQestionText) {
        return;
      }
      this.touchTimer = setTimeout(function() {
        self.clickPinchIn(text);
      }, constants.LONGTOUCH_DURATION);
    },
    /**
     * 長押しイベント終了
     */
    onTouchEnd: function() {
      clearTimeout(this.touchTimer);
    },
    /**
     * Actの拡大表示通知を受け取る
     */
    recieveActPinchIn: function() {
      this.tempCurrentData = this.currentData;
    },
    /**
     * 画像用テキスト表示切り替え
     *
     * @param {Boolean} visible true:表示, false:非表示
     */
    changeImageTextDisplay: function(visible) {
      if (this.isMobile()) {
        const imageText = $(".card .image p");
        if (visible) {
          // 画像用テキストのフォントサイズ調整
          imageText.textfill({
            maxFontPixels: constants.MAX_IMAGE_TEXT_FONT_SIZE
          });
          // 表示
          imageText.css({ visibility: "visible" });
        } else {
          // 非表示
          imageText.css({ visibility: "hidden" });
        }
      }
    },
    /**
     * 出題文領域自動サイズ調整処理
     */
    autoAdjustTopArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let inputClone;
      let textClone;
      const cloneInput = function(targetText) {
        // 出題文領域を複製
        inputClone = $(".toparea-play > .flexcenter > .item > .input").clone();
        inputClone.empty();
        inputClone.append("<span/>");
        textClone = inputClone.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        textClone.html(targetText);
        inputClone.appendTo(".toparea-play > .flexcenter");
      };

      let basicTexts = this.getAllBasicTexts(this.pathstep.acts, this.productLanguage, this.scriptType, this.scriptSystems.default, true);
      // 出題文領域のフォントサイズを求める
      const MAX_AUTO_ADJUST_FONT_SIZE = constants.AUTO_ADJUST_FONT_SIZE[this.textSize].max;
      for (let displayMode in basicTexts) {
        for (let basicText of basicTexts[displayMode]) {
          cloneInput(basicText);
          let topAreaFontSize = this.topAreaFontSize[displayMode] ? this.topAreaFontSize[displayMode] : MAX_AUTO_ADJUST_FONT_SIZE;
          let adjustedFontSize = this.getAutoAdjustFontSize(inputClone, textClone, topAreaFontSize);
          this.topAreaFontSize[displayMode] = adjustedFontSize;
          inputClone.remove();
        }
      }
      // 出題文領域の高さを求める
      for (let displayMode in basicTexts) {
        for (let basicText of basicTexts[displayMode]) {
          cloneInput(basicText);
          let topAreaHeight = this.topAreaHeight[displayMode] ? this.topAreaHeight[displayMode] : 0;
          let adjustedHeight = this.getAutoAdjustHeight(inputClone, textClone, topAreaHeight, this.topAreaFontSize[displayMode]);
          this.topAreaHeight[displayMode] = adjustedHeight;
          inputClone.remove();
        }
      }
    },
    /**
     * カード領域自動サイズ調整処理
     */
    autoAdjustCardArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let clones = {};
      const cloneCard = function(targetText) {
        // カードを複製
        clones.card = $(".card-inner:first > div > div > .item:first").clone();
        clones.textArea = clones.card.children("div").children("p");
        clones.textArea.empty();
        clones.textArea.append("<span/>");
        clones.text = clones.textArea.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        clones.text.html(targetText);
        clones.card.appendTo(".card-inner:first > div > div");
      };

      // 対象テキストを取得
      let targetTexts = this.getAllBasicTexts(this.pathstep.acts, this.productLanguage, this.scriptType, this.scriptSystems.default, false);

      // サイズを確定させる
      this.fixCardAreaSize(targetTexts, cloneCard, clones);
    },
    /**
     * 出題文領域サイズ適用
     */
    applyTopAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 適用サイズ取得
      let fixedHeight = this.topAreaHeight[this.displayMode];
      let fixedFontSize = this.topAreaFontSize[this.displayMode];
      // 確定した高さとフォントサイズを設定
      let topArea = $(".toparea-play");
      let topAreaInput = topArea.children(".flexcenter").children(".item").children(".input");
      topAreaInput.height(fixedHeight);
      topArea.height(topAreaInput.outerHeight());
      topAreaInput.css({ fontSize: fixedFontSize });
      // カード領域の位置と高さを調整する
      let topAreaHeight = topArea.outerHeight();
      let cardsContainer = $(".cards-container");
      let cardsContainerTop = cardsContainer.offset().top;
      let cardsContainerHeight = cardsContainer.outerHeight();
      let footerHeight = $(".sp-second-header").outerHeight();
      cardsContainer.css({
        top: topAreaHeight,
        height: cardsContainerHeight + cardsContainerTop - topAreaHeight - footerHeight
      });
    },
    /**
     * カード領域サイズ適用
     */
    applyCardAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 適用サイズ取得
      let fixedHeight = this.cardAreaHeight[this.displayMode];
      let fixedFontSize = this.cardAreaFontSize[this.displayMode];
      // 確定した高さとフォントサイズを設定
      let textArea = $(".card-inner .item > div > p");
      textArea.height(fixedHeight);
      textArea.css({ fontSize: fixedFontSize });
    },
    /**
     * 自動調整サイズ適用
     */
    applyAutoAdjustSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      this.applyTopAreaSize();
      this.applyCardAreaSize();
    }
  },
  mounted: function() {
    if (this.lessonState == storeConstants.LESSON_STATE_START) {
      // 問題の出題
      this.setQuestionType();
    }

    if (this.isMobile()) {
      // 画像用テキスト表示変更
      this.changeImageTextDisplay(false);
      // 自動調整初期処理
      this.initAutoAdjust([".page-content"], [".cards-container"]);
    }
  },
  watch: {
    /**
     * ツールバー「全解答を表示する」の選択状態を監視する
     */
    dispAllAnswerStatus: function(newstatus) {
      this.log("A1 watch dispAllAnswerStatus");

      if (this.dispAllAnswerStatus) {
        this.showAllAnswer();
        if (this.allCorrectTimer != null) {
          clearTimeout(this.allCorrectTimer);
        }
      } else {
        this.hideAllAnswer();
        this.givenPlaySounds();
      }
    },
    /**
     * スコア表示状態を監視する
     */
    lessonState: function(newstatus) {
      this.log("A1 watch lessonState");

      if (this.lessonState == storeConstants.LESSON_STATE_START) {
        // 問題の出題
        this.setQuestionType();
      } else if (this.lessonState == storeConstants.LESSON_STATE_STOP) {
        this.$emit("stopAct");
      } else if (this.lessonState == storeConstants.LESSON_STATE_PAUSE) {
        if (this.allCorrectTimer != null) {
          clearTimeout(this.allCorrectTimer);
        }
      } else if (this.lessonState == storeConstants.LESSON_STATE_RESTART) {
        if (this.isShowPinchIn) {
          this.isShowPinchIn = false;
          return;
        }
        // 全解答表示中は何もしない
        if (!this.dispAllAnswerStatus) {
          this.givenPlaySounds();
        }
      }

      if (this.isMobile()) {
        // 表示領域自動調整
        let funcs = [this.autoAdjustTopArea, this.autoAdjustCardArea, this.applyAutoAdjustSize];
        this.autoAdjustFirstShown(funcs, [".cards-container"]);
        // スクロールアイコン表示
        this.$emit("showScrollIcon", document.getElementsByClassName("cards-container")[0]);
      }
    },
    /**
     * 中国語表示切り替え
     * @param string newstatus
     */
    scriptType: function(newstatus) {
      // 表示テキスト一覧取得
      if (this.currentData) {
        this.eText = this.getLanguageBasicText(this.currentData.texts, this.productLanguage, newstatus, this.displayMode, this.scriptSystems.default);
      }
      // 拡大表示ボタン表示
      this.showPinchInBtn = this.isShowPinchInBtn(this.productLanguage, this.displayMode);
      // 自動調整サイズ適用
      this.applyAutoAdjustSize();
    },
    /**
     * 表示モード切り替え
     * @param string newstatus
     */
    displayMode: function(newstatus) {
      // 問題テキスト切り替え
      if (this.currentData) {
        this.eText = this.getLanguageBasicText(this.currentData.texts, this.productLanguage, this.scriptType, newstatus, this.scriptSystems.default);
      }
      // 拡大表示ボタン表示
      this.showPinchInBtn = this.isShowPinchInBtn(this.productLanguage, this.displayMode);
      // 自動調整サイズ適用
      this.applyAutoAdjustSize();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/card";
</style>



// WEBPACK FOOTER //
// A1.vue?2cd53fd3